import axios from "axios";

export const solvenciasService = {
  async apiCall(endpoint, token) {
    try {
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  async procesarSolvencias({
    operacion,
    idSolve,
    idContri,
    nombre,
    cedula,
    dire,
    fecha,
    valido,
    dirigido,
    solic,
    fechaVenc,
    token,
    conexion,
  }) {
    const campos = "*";
    const nomtab = `solvencia_act(${operacion}, ${idSolve}, ${idContri}, '${encodeURIComponent(nombre)}', '${cedula}', '${dire}', '${fecha}', '${valido}', '${dirigido}', ${solic}, '${fechaVenc}')`;
    const orden = "1=1";
    const endpoint = `${conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    return await this.apiCall(endpoint, token);
  },
};
